const deadCache = new Set<string>();
const liveCache = new Set<string>();

/** Skip Nest `/static/` and other dead files — never request them (avoids console 404s). */
export async function isReachableImage(url: string): Promise<boolean> {
  if (!url) return false;
  if (liveCache.has(url)) return true;
  if (deadCache.has(url)) return false;

  // Nest local uploads are retired — treat as permanently dead without a network call.
  if (/\/static\//i.test(url) || /wikimedia\.org|wikipedia\.org/i.test(url)) {
    deadCache.add(url);
    return false;
  }

  liveCache.add(url);
  return true;
}
